"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48482],{

/***/ 227065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NewMoneyColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewMoneyColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "24", height: "24", rx: "8", fill: "#F6FFED" }
      },
      {
        tag: "path",
        attr: {
          d: "M16.6667 6.66699H7.33333C6.4496 6.66805 5.60237 7.01958 4.97748 7.64447C4.35259 8.26936 4.00106 9.1166 4 10.0003V14.0003C4.00106 14.8841 4.35259 15.7313 4.97748 16.3562C5.60237 16.9811 6.4496 17.3326 7.33333 17.3337H16.6667C17.5504 17.3326 18.3976 16.9811 19.0225 16.3562C19.6474 15.7313 19.9989 14.8841 20 14.0003V10.0003C19.9989 9.1166 19.6474 8.26936 19.0225 7.64447C18.3976 7.01958 17.5504 6.66805 16.6667 6.66699ZM6.66667 15.3337C6.53481 15.3337 6.40592 15.2946 6.29629 15.2213C6.18665 15.1481 6.10121 15.0439 6.05075 14.9221C6.00029 14.8003 5.98709 14.6663 6.01281 14.5369C6.03853 14.4076 6.10203 14.2888 6.19526 14.1956C6.2885 14.1024 6.40729 14.0389 6.53661 14.0131C6.66593 13.9874 6.79997 14.0006 6.92179 14.0511C7.04361 14.1015 7.14773 14.187 7.22098 14.2966C7.29423 14.4062 7.33333 14.5351 7.33333 14.667C7.33333 14.8438 7.2631 15.0134 7.13807 15.1384C7.01305 15.2634 6.84348 15.3337 6.66667 15.3337ZM6.66667 10.0003C6.53481 10.0003 6.40592 9.96123 6.29629 9.88797C6.18665 9.81472 6.10121 9.7106 6.05075 9.58878C6.00029 9.46696 5.98709 9.33292 6.01281 9.2036C6.03853 9.07428 6.10203 8.95549 6.19526 8.86225C6.2885 8.76902 6.40729 8.70553 6.53661 8.6798C6.66593 8.65408 6.79997 8.66728 6.92179 8.71774C7.04361 8.7682 7.14773 8.85365 7.22098 8.96328C7.29423 9.07291 7.33333 9.2018 7.33333 9.33366C7.33333 9.51047 7.2631 9.68004 7.13807 9.80506C7.01305 9.93009 6.84348 10.0003 6.66667 10.0003ZM12 14.667C11.4726 14.667 10.957 14.5106 10.5185 14.2176C10.0799 13.9246 9.73815 13.5081 9.53632 13.0208C9.33449 12.5335 9.28168 11.9974 9.38457 11.4801C9.48747 10.9628 9.74144 10.4876 10.1144 10.1147C10.4873 9.74177 10.9625 9.48779 11.4798 9.3849C11.997 9.282 12.5332 9.33481 13.0205 9.53665C13.5078 9.73848 13.9242 10.0803 14.2173 10.5188C14.5103 10.9573 14.6667 11.4729 14.6667 12.0003C14.6667 12.7076 14.3857 13.3858 13.8856 13.8859C13.3855 14.386 12.7072 14.667 12 14.667ZM17.3333 15.3337C17.2015 15.3337 17.0726 15.2946 16.963 15.2213C16.8533 15.1481 16.7679 15.0439 16.7174 14.9221C16.667 14.8003 16.6538 14.6663 16.6795 14.5369C16.7052 14.4076 16.7687 14.2888 16.8619 14.1956C16.9552 14.1024 17.074 14.0389 17.2033 14.0131C17.3326 13.9874 17.4666 14.0006 17.5885 14.0511C17.7103 14.1015 17.8144 14.187 17.8876 14.2966C17.9609 14.4062 18 14.5351 18 14.667C18 14.8438 17.9298 15.0134 17.8047 15.1384C17.6797 15.2634 17.5101 15.3337 17.3333 15.3337ZM17.3333 10.0003C17.2015 10.0003 17.0726 9.96123 16.963 9.88797C16.8533 9.81472 16.7679 9.7106 16.7174 9.58878C16.667 9.46696 16.6538 9.33292 16.6795 9.2036C16.7052 9.07428 16.7687 8.95549 16.8619 8.86225C16.9552 8.76902 17.074 8.70553 17.2033 8.6798C17.3326 8.65408 17.4666 8.66728 17.5885 8.71774C17.7103 8.7682 17.8144 8.85365 17.8876 8.96328C17.9609 9.07291 18 9.2018 18 9.33366C18 9.51047 17.9298 9.68004 17.8047 9.80506C17.6797 9.93009 17.5101 10.0003 17.3333 10.0003ZM13.3333 12.0003C13.3333 12.264 13.2551 12.5218 13.1086 12.7411C12.9621 12.9604 12.7539 13.1312 12.5102 13.2322C12.2666 13.3331 11.9985 13.3595 11.7399 13.308C11.4812 13.2566 11.2437 13.1296 11.0572 12.9431C10.8707 12.7567 10.7437 12.5191 10.6923 12.2604C10.6408 12.0018 10.6672 11.7337 10.7682 11.4901C10.8691 11.2464 11.04 11.0382 11.2592 10.8917C11.4785 10.7452 11.7363 10.667 12 10.667C12.3536 10.667 12.6928 10.8075 12.9428 11.0575C13.1929 11.3076 13.3333 11.6467 13.3333 12.0003Z",
          fill: "#52C41A"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 803537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ NewMoreProductOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewMoreProductOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_2774_2758)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M4.66667 0H2.66667C1.95942 0 1.28115 0.280952 0.781049 0.781049C0.280952 1.28115 0 1.95942 0 2.66667L0 4.66667C0 5.37391 0.280952 6.05219 0.781049 6.55229C1.28115 7.05238 1.95942 7.33333 2.66667 7.33333H4.66667C5.37391 7.33333 6.05219 7.05238 6.55229 6.55229C7.05238 6.05219 7.33333 5.37391 7.33333 4.66667V2.66667C7.33333 1.95942 7.05238 1.28115 6.55229 0.781049C6.05219 0.280952 5.37391 0 4.66667 0V0ZM6 4.66667C6 5.02029 5.85952 5.35943 5.60948 5.60948C5.35943 5.85952 5.02029 6 4.66667 6H2.66667C2.31304 6 1.97391 5.85952 1.72386 5.60948C1.47381 5.35943 1.33333 5.02029 1.33333 4.66667V2.66667C1.33333 2.31304 1.47381 1.97391 1.72386 1.72386C1.97391 1.47381 2.31304 1.33333 2.66667 1.33333H4.66667C5.02029 1.33333 5.35943 1.47381 5.60948 1.72386C5.85952 1.97391 6 2.31304 6 2.66667V4.66667Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M13.3332 0H11.3332C10.6259 0 9.94765 0.280952 9.44755 0.781049C8.94745 1.28115 8.6665 1.95942 8.6665 2.66667V4.66667C8.6665 5.37391 8.94745 6.05219 9.44755 6.55229C9.94765 7.05239 10.6259 7.33334 11.3332 7.33334H13.3332C14.0404 7.33334 14.7187 7.05239 15.2188 6.55229C15.7189 6.05219 15.9998 5.37391 15.9998 4.66667V2.66667C15.9998 1.95942 15.7189 1.28115 15.2188 0.781049C14.7187 0.280952 14.0404 0 13.3332 0V0ZM14.6665 4.66667C14.6665 5.02029 14.526 5.35943 14.276 5.60948C14.0259 5.85953 13.6868 6 13.3332 6H11.3332C10.9795 6 10.6404 5.85953 10.3904 5.60948C10.1403 5.35943 9.99984 5.02029 9.99984 4.66667V2.66667C9.99984 2.31305 10.1403 1.97391 10.3904 1.72386C10.6404 1.47381 10.9795 1.33333 11.3332 1.33333H13.3332C13.6868 1.33333 14.0259 1.47381 14.276 1.72386C14.526 1.97391 14.6665 2.31305 14.6665 2.66667V4.66667Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M4.66667 8.66667H2.66667C1.95942 8.66667 1.28115 8.94762 0.781049 9.44772C0.280952 9.94782 0 10.6261 0 11.3333L0 13.3333C0 14.0406 0.280952 14.7189 0.781049 15.219C1.28115 15.7191 1.95942 16 2.66667 16H4.66667C5.37391 16 6.05219 15.7191 6.55229 15.219C7.05238 14.7189 7.33333 14.0406 7.33333 13.3333V11.3333C7.33333 10.6261 7.05238 9.94782 6.55229 9.44772C6.05219 8.94762 5.37391 8.66667 4.66667 8.66667ZM6 13.3333C6 13.687 5.85952 14.0261 5.60948 14.2762C5.35943 14.5262 5.02029 14.6667 4.66667 14.6667H2.66667C2.31304 14.6667 1.97391 14.5262 1.72386 14.2762C1.47381 14.0261 1.33333 13.687 1.33333 13.3333V11.3333C1.33333 10.9797 1.47381 10.6406 1.72386 10.3905C1.97391 10.1405 2.31304 10 2.66667 10H4.66667C5.02029 10 5.35943 10.1405 5.60948 10.3905C5.85952 10.6406 6 10.9797 6 11.3333V13.3333Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M13.3332 8.66667H11.3332C10.6259 8.66667 9.94765 8.94762 9.44755 9.44772C8.94745 9.94782 8.6665 10.6261 8.6665 11.3333V13.3333C8.6665 14.0406 8.94745 14.7189 9.44755 15.219C9.94765 15.7191 10.6259 16 11.3332 16H13.3332C14.0404 16 14.7187 15.7191 15.2188 15.219C15.7189 14.7189 15.9998 14.0406 15.9998 13.3333V11.3333C15.9998 10.6261 15.7189 9.94782 15.2188 9.44772C14.7187 8.94762 14.0404 8.66667 13.3332 8.66667ZM14.6665 13.3333C14.6665 13.687 14.526 14.0261 14.276 14.2762C14.0259 14.5262 13.6868 14.6667 13.3332 14.6667H11.3332C10.9795 14.6667 10.6404 14.5262 10.3904 14.2762C10.1403 14.0261 9.99984 13.687 9.99984 13.3333V11.3333C9.99984 10.9797 10.1403 10.6406 10.3904 10.3905C10.6404 10.1405 10.9795 10 11.3332 10H13.3332C13.6868 10 14.0259 10.1405 14.276 10.3905C14.526 10.6406 14.6665 10.9797 14.6665 11.3333V13.3333Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_2774_2758" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 247693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ NewSearchOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewSearchOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.8045 14.8625L11.8252 10.8831C12.9096 9.55686 13.4428 7.86453 13.3144 6.15617C13.1861 4.44782 12.406 2.85415 11.1356 1.70481C9.86516 0.555472 8.20158 -0.0616068 6.48895 -0.0187856C4.77632 0.0240356 3.14566 0.723481 1.93426 1.93487C0.72287 3.14627 0.0234252 4.77693 -0.019396 6.48956C-0.0622172 8.20219 0.554862 9.86577 1.7042 11.1362C2.85354 12.4066 4.44721 13.1867 6.15556 13.315C7.86392 13.4434 9.55625 12.9102 10.8825 11.8258L14.8619 15.8051C14.9876 15.9266 15.156 15.9938 15.3308 15.9922C15.5056 15.9907 15.6728 15.9206 15.7964 15.797C15.92 15.6734 15.9901 15.5062 15.9916 15.3314C15.9932 15.1566 15.926 14.9882 15.8045 14.8625ZM6.66652 12.0005C5.61169 12.0005 4.58054 11.6877 3.70348 11.1016C2.82642 10.5156 2.14283 9.68265 1.73916 8.70811C1.3355 7.73357 1.22988 6.66122 1.43567 5.62665C1.64145 4.59208 2.14941 3.64178 2.89529 2.8959C3.64117 2.15002 4.59147 1.64206 5.62604 1.43628C6.6606 1.23049 7.73296 1.33611 8.7075 1.73977C9.68204 2.14344 10.515 2.82703 11.101 3.70409C11.6871 4.58115 11.9999 5.6123 11.9999 6.66713C11.9983 8.08113 11.4359 9.43676 10.436 10.4366C9.43615 11.4365 8.08052 11.9989 6.66652 12.0005Z",
          fill: "black"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 489693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ NewVoucherColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewVoucherColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
          fill: "#FFF1F0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8 20H9.42C9.71836 19.9972 10.0073 19.8953 10.2415 19.7105C10.4757 19.5256 10.6419 19.2682 10.714 18.9787C10.7912 18.6968 10.9588 18.4481 11.1912 18.2708C11.4236 18.0935 11.7077 17.9974 12 17.9974C12.2923 17.9974 12.5764 18.0935 12.8088 18.2708C13.0412 18.4481 13.2088 18.6968 13.286 18.9787C13.3581 19.2682 13.5243 19.5256 13.7585 19.7105C13.9927 19.8953 14.2816 19.9972 14.58 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V15.3333H15.3333C15.1565 15.3333 14.987 15.2631 14.8619 15.1381C14.7369 15.013 14.6667 14.8435 14.6667 14.6667C14.6667 14.4899 14.7369 14.3203 14.8619 14.1953C14.987 14.0702 15.1565 14 15.3333 14H18V7.33333C17.9989 6.4496 17.6474 5.60237 17.0225 4.97748C16.3976 4.35259 15.5504 4.00106 14.6667 4L14.58 4C14.2816 4.00283 13.9927 4.10468 13.7585 4.28953C13.5243 4.47439 13.3581 4.7318 13.286 5.02133C13.2088 5.30323 13.0412 5.55195 12.8088 5.72924C12.5764 5.90652 12.2923 6.00256 12 6.00256C11.7077 6.00256 11.4236 5.90652 11.1912 5.72924C10.9588 5.55195 10.7912 5.30323 10.714 5.02133C10.6419 4.7318 10.4757 4.47439 10.2415 4.28953C10.0073 4.10468 9.71836 4.00283 9.42 4H9.33333C8.4496 4.00106 7.60237 4.35259 6.97748 4.97748C6.35259 5.60237 6.00106 6.4496 6 7.33333V14H8.66667C8.84348 14 9.01305 14.0702 9.13807 14.1953C9.2631 14.3203 9.33333 14.4899 9.33333 14.6667C9.33333 14.8435 9.2631 15.013 9.13807 15.1381C9.01305 15.2631 8.84348 15.3333 8.66667 15.3333H6V18C6 18.5304 6.21071 19.0391 6.58579 19.4142C6.96086 19.7893 7.46957 20 8 20ZM11.3333 14H12.6667C12.8435 14 13.013 14.0702 13.1381 14.1953C13.2631 14.3203 13.3333 14.4899 13.3333 14.6667C13.3333 14.8435 13.2631 15.013 13.1381 15.1381C13.013 15.2631 12.8435 15.3333 12.6667 15.3333H11.3333C11.1565 15.3333 10.987 15.2631 10.8619 15.1381C10.7369 15.013 10.6667 14.8435 10.6667 14.6667C10.6667 14.4899 10.7369 14.3203 10.8619 14.1953C10.987 14.0702 11.1565 14 11.3333 14Z",
          fill: "#F5222D"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 773048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ NewsOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewsOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.8335 11.1667L6.16683 8.75V12.985L2.8335 11.1667Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21.1668 11.1667L17.8335 8.75V12.985L21.1668 11.1667Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.16683 8.75L2.8335 11.1667V21.1667H21.1668V11.1667L17.8335 8.75",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.16699 12.9999V2.83325H17.8337V12.9999",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.8335 11.1665L21.1668 21.1665",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21.1667 11.1665L12 16.1665",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.5 7H14.5",
          stroke: "#82869E",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.5 10.3333H14.5",
          stroke: "#82869E",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 46968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OrderFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const OrderFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 2C4.89543 2 4 2.89543 4 4V20.5304C4 20.77 4.26704 20.9129 4.46641 20.78L6.17257 19.6425C6.50847 19.4186 6.94607 19.4186 7.28197 19.6425L8.89985 20.7211C9.23574 20.945 9.67335 20.945 10.0092 20.7211L11.6271 19.6425C11.963 19.4186 12.4006 19.4186 12.7365 19.6425L14.3544 20.7211C14.6903 20.945 15.1279 20.945 15.4638 20.7211L17.0817 19.6425C17.4176 19.4186 17.8552 19.4186 18.1911 19.6425L19.8972 20.78C20.0966 20.9129 20.3636 20.77 20.3636 20.5304V4C20.3636 2.89543 19.4682 2 18.3636 2H6ZM6.88623 7.45459C6.88623 7.04038 7.22202 6.70459 7.63623 6.70459H12.1817C12.5959 6.70459 12.9317 7.04038 12.9317 7.45459C12.9317 7.8688 12.5959 8.20459 12.1817 8.20459H7.63623C7.22202 8.20459 6.88623 7.8688 6.88623 7.45459ZM15.0684 7.45459C15.0684 7.04038 15.4041 6.70459 15.8184 6.70459H16.7275C17.1417 6.70459 17.4775 7.04038 17.4775 7.45459C17.4775 7.8688 17.1417 8.20459 16.7275 8.20459H15.8184C15.4041 8.20459 15.0684 7.8688 15.0684 7.45459ZM7.63623 10.3408C7.22202 10.3408 6.88623 10.6766 6.88623 11.0908C6.88623 11.505 7.22202 11.8408 7.63623 11.8408H12.1817C12.5959 11.8408 12.9317 11.505 12.9317 11.0908C12.9317 10.6766 12.5959 10.3408 12.1817 10.3408H7.63623ZM15.0684 11.0908C15.0684 10.6766 15.4041 10.3408 15.8184 10.3408H16.7275C17.1417 10.3408 17.4775 10.6766 17.4775 11.0908C17.4775 11.505 17.1417 11.8408 16.7275 11.8408H15.8184C15.4041 11.8408 15.0684 11.505 15.0684 11.0908ZM7.63623 13.9775C7.22202 13.9775 6.88623 14.3133 6.88623 14.7275C6.88623 15.1418 7.22202 15.4775 7.63623 15.4775H12.1817C12.5959 15.4775 12.9317 15.1418 12.9317 14.7275C12.9317 14.3133 12.5959 13.9775 12.1817 13.9775H7.63623ZM15.0684 14.7275C15.0684 14.3133 15.4041 13.9775 15.8184 13.9775H16.7275C17.1417 13.9775 17.4775 14.3133 17.4775 14.7275C17.4775 15.1418 17.1417 15.4775 16.7275 15.4775H15.8184C15.4041 15.4775 15.0684 15.1418 15.0684 14.7275Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 7783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PackagedHamperOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PackagedHamperOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M20.7474 10.4608L20.7428 10.4421L18.1131 3.76006C17.9959 3.38271 17.6467 3.12256 17.2506 3.12256H6.59119C6.19275 3.12256 5.83885 3.3874 5.72635 3.76943L3.26775 10.3835L3.26072 10.3999L3.25604 10.4187C3.22557 10.5335 3.21619 10.6507 3.2326 10.7655C3.23025 10.803 3.22791 10.8405 3.22791 10.878V19.4538C3.22853 19.8316 3.37886 20.1936 3.64597 20.4608C3.91307 20.7279 4.27517 20.8782 4.65291 20.8788H19.3529C20.1381 20.8788 20.7779 20.239 20.7803 19.4538V10.878C20.7803 10.8476 20.7803 10.8171 20.7779 10.7913C20.7873 10.6765 20.7779 10.5663 20.7474 10.4608ZM13.8146 9.45303L13.8076 9.821C13.7888 10.8733 13.0623 11.5812 12.0006 11.5812C11.4826 11.5812 11.0373 11.4147 10.7162 11.0983C10.3951 10.7819 10.2193 10.3413 10.2099 9.821L10.2029 9.45303H5.37947L7.24275 4.92256H16.599L18.5138 9.45303H13.8146ZM5.02557 11.253H8.71229C9.28182 12.5913 10.4935 13.3812 12.0029 13.3812C12.7928 13.3812 13.5263 13.1608 14.1193 12.7437C14.6396 12.378 15.0451 11.8671 15.3076 11.253H18.9756V19.0788H5.02557V11.253Z",
          fill: "#F5222D"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 640878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ PaymentOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PaymentOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.75 5.5C4.05964 5.5 3.5 6.05964 3.5 6.75V8.25H20.5V6.75C20.5 6.05964 19.9404 5.5 19.25 5.5H4.75ZM3.5 11.25V9.75H20.5V11.25H3.5ZM3.5 12.75V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H19.25C19.9404 18.5 20.5 17.9404 20.5 17.25V12.75H3.5ZM2 6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7688 4 22 5.23122 22 6.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75ZM5.25 16C5.25 15.5858 5.58579 15.25 6 15.25H10C10.4142 15.25 10.75 15.5858 10.75 16C10.75 16.4142 10.4142 16.75 10 16.75H6C5.58579 16.75 5.25 16.4142 5.25 16ZM16 15.25C15.5858 15.25 15.25 15.5858 15.25 16C15.25 16.4142 15.5858 16.75 16 16.75H17C17.4142 16.75 17.75 16.4142 17.75 16C17.75 15.5858 17.4142 15.25 17 15.25H16Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 810313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ PbNavigationRoundFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PbNavigationRoundFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "24", height: "24", rx: "12", fill: "#4D4D4D" }
      },
      {
        tag: "path",
        attr: {
          d: "M14.3335 7.3335L9.66683 12.0002L14.3335 16.6668",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PhoneCallColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PhoneCallColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { version: "1.1", viewBox: "0 0 467 444" },
    child: [
      {
        tag: "g",
        attr: {},
        child: [
          {
            tag: "g",
            attr: { id: "Layer_1" },
            child: [
              {
                tag: "g",
                attr: {},
                child: [
                  {
                    tag: "circle",
                    attr: {
                      cx: "233.5",
                      cy: "222",
                      r: "221.4",
                      fill: "#467bf0"
                    }
                  },
                  {
                    tag: "path",
                    attr: {
                      d: "M168.6,107.1c3.4,2.6,5.4,6,16.1,26.5,3.3,6.3,8.4,15.9,11.2,21.2,7.5,14.3,7,16.8-5.1,28.9-3.6,3.5-6.8,7.2-7.1,8.2-.8,2.2,2.4,12.7,5.2,16.5,1.1,1.7,2.1,3.3,2.1,3.7s2.1,3.7,4.7,7.3c7.6,10.7,32,35.1,40.9,41,1,.7,4.4,2.9,7.4,4.9,6.1,4,16.4,7.7,19.5,6.9,1.1-.3,5.6-4.2,10-8.7,8.1-8.3,12.2-10.9,17.2-10.9s22.7,11.2,39.8,21.8c1.7,1,5.9,3.6,9.5,5.7,7,4.2,7.8,4.9,9.8,8.3,2.5,4.5.9,8.2-7,15.9-2.9,2.9-11,11-18,17.9-7,6.9-14.4,13.5-16.5,14.6-6.5,3.6-16.7,3.3-34.3-.8-19-4.5-50.9-22-70.3-38.6-3.7-3.2-19.8-17.8-24.9-23-6.5-6.6-8.2-8.2-14.7-15.5-5.3-6-20.1-25.1-20.1-25.9s-1.1-2-2.4-3.7c-6.9-9.4-18.5-34.5-21.7-47.2-4.7-18.4-4.9-27-.8-34.9,2.6-5.1,36.9-39.3,41.2-41.1,4.3-1.9,4.5-1.9,8.3,1Z",
                      fill: "#fff"
                    }
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 943329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ PhoneOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PhoneOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.9774 13.9669L13.0505 15.8677C12.0457 15.2618 11.1122 14.5448 10.2677 13.7302C9.45438 12.8843 8.73749 11.9507 8.13027 10.9465L10.0292 9.01967C10.2645 8.78079 10.332 8.42345 10.2002 8.11518L8.22027 3.50005C8.0586 3.12393 7.64588 2.92293 7.25008 3.02756L3.61954 3.98784C3.24616 4.08464 2.98926 4.42667 3.00035 4.81223C3.23135 9.03476 4.98702 13.03 7.94127 16.0558C10.9676 19.0109 14.9639 20.767 19.1875 20.9976C19.5736 21.0106 19.9168 20.7535 20.0128 20.3793L20.9722 16.747C21.0773 16.3514 20.8766 15.9385 20.5006 15.7768L15.8846 13.7977C15.5759 13.664 15.217 13.7309 14.9774 13.9669Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 418536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PlayOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PlayOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12V12Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.9411 9.05794L14.8231 11.3539C14.9352 11.4203 15.0282 11.5147 15.0927 11.6279C15.1573 11.7411 15.1912 11.8691 15.1912 11.9994C15.1912 12.1297 15.1573 12.2578 15.0927 12.371C15.0282 12.4842 14.9352 12.5786 14.8231 12.6449L10.9411 14.9409C10.8272 15.0084 10.6974 15.0444 10.565 15.0455C10.4326 15.0465 10.3023 15.0125 10.1873 14.9469C10.0724 14.8813 9.9768 14.7864 9.91036 14.6719C9.84393 14.5574 9.80898 14.4273 9.80908 14.2949V9.70394C9.80898 9.57155 9.84393 9.4415 9.91036 9.32699C9.9768 9.21248 10.0724 9.11759 10.1873 9.05197C10.3023 8.98636 10.4326 8.95234 10.565 8.95339C10.6974 8.95444 10.8272 8.99051 10.9411 9.05794Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 8130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ PrinterOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PrinterOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.34782 1.25C5.93361 1.25 5.59782 1.58579 5.59782 2V3.73913C5.59782 4.15334 5.93361 4.48913 6.34782 4.48913C6.76204 4.48913 7.09782 4.15334 7.09782 3.73913V2.75H16.0326V3.73913C16.0326 4.15334 16.3684 4.48913 16.7826 4.48913C17.1968 4.48913 17.5326 4.15334 17.5326 3.73913V2C17.5326 1.58579 17.1968 1.25 16.7826 1.25H6.34782ZM17.2174 10.3911C17.7697 10.3911 18.2174 9.9434 18.2174 9.39111C18.2174 8.83883 17.7697 8.39111 17.2174 8.39111C16.6651 8.39111 16.2174 8.83883 16.2174 9.39111C16.2174 9.9434 16.6651 10.3911 17.2174 10.3911ZM5.47826 7.09766C3.97148 7.09766 2.75 8.31914 2.75 9.82592V14.7824C2.75 15.4728 3.30964 16.0324 4 16.0324H5.59782V15.3042C5.59782 13.7854 6.82904 12.5542 8.34782 12.5542H14.7826C16.3014 12.5542 17.5326 13.7854 17.5326 15.3042V16.0324H19.1304C19.8208 16.0324 20.3804 15.4728 20.3804 14.7824V9.82592C20.3804 8.31914 19.159 7.09766 17.6522 7.09766H5.47826ZM17.5326 17.5324H19.1304C20.6492 17.5324 21.8804 16.3012 21.8804 14.7824V9.82592C21.8804 7.49071 19.9874 5.59766 17.6522 5.59766H5.47826C3.14306 5.59766 1.25 7.49071 1.25 9.82592V14.7824C1.25 16.3012 2.48122 17.5324 4 17.5324H5.59782V19.1303C5.59782 20.6491 6.82904 21.8803 8.34782 21.8803H14.7826C16.3014 21.8803 17.5326 20.6491 17.5326 19.1303V17.5324ZM7.09782 16.7841V19.1303C7.09782 19.8206 7.65747 20.3803 8.34782 20.3803H14.7826C15.473 20.3803 16.0326 19.8206 16.0326 19.1303V15.3042C16.0326 14.6138 15.473 14.0542 14.7826 14.0542H8.34782C7.65747 14.0542 7.09782 14.6138 7.09782 15.3042V16.7807C7.09783 16.7813 7.09783 16.7819 7.09783 16.7824C7.09783 16.783 7.09783 16.7836 7.09782 16.7841Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 11069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ProfileFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ProfileFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 2.25C9.11155 2.25 6.767 4.64206 6.767 7.517C6.767 10.3993 9.1189 12.75 12 12.75C14.8884 12.75 17.233 10.3579 17.233 7.483C17.233 4.60068 14.8811 2.25 12 2.25ZM8 14.25C5.38579 14.25 3.25 16.3858 3.25 19V20C3.25 20.9642 4.03579 21.75 5 21.75H19C19.9642 21.75 20.75 20.9642 20.75 20V19C20.75 16.3858 18.6142 14.25 16 14.25H8Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 539571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ProfileOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ProfileOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12 12C9.533 12 7.517 9.985 7.517 7.517C7.517 5.049 9.533 3 12 3C14.467 3 16.483 5.015 16.483 7.483C16.483 9.951 14.467 12 12 12ZM19 21H5C4.45 21 4 20.55 4 20V19C4 16.8 5.8 15 8 15H16C18.2 15 20 16.8 20 19V20C20 20.55 19.55 21 19 21Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 228128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ QaOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const QaOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 18.4546C12.5523 18.4546 13 18.0069 13 17.4546C13 16.9023 12.5523 16.4546 12 16.4546C11.4477 16.4546 11 16.9023 11 17.4546C11 18.0069 11.4477 18.4546 12 18.4546ZM10.3513 7.74078C11.1422 7.39128 12.0464 7.24131 12.8171 7.31365C13.6061 7.38772 14.1113 7.67378 14.3347 8.0354C14.8461 8.86293 14.6033 9.96445 13.3706 11.0089C12.0205 12.1529 11.25 12.9835 11.25 14.273C11.25 14.6872 11.5858 15.023 12 15.023C12.4142 15.023 12.75 14.6872 12.75 14.273C12.75 13.7443 12.9631 13.3203 14.3403 12.1533C15.8349 10.8869 16.6903 8.9939 15.6107 7.24689C15.0388 6.32123 13.9817 5.91638 12.9573 5.82022C11.9145 5.72234 10.7542 5.92282 9.74503 6.36878C9.36616 6.53621 9.19476 6.97907 9.36219 7.35793C9.52962 7.7368 9.97248 7.90821 10.3513 7.74078Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 923584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ QrCodeColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const QrCodeColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M4.693 2C3.206 2 2 3.206 2 4.695V7.389C2 7.884 2.401 8.287 2.898 8.287C3.394 8.287 3.795 7.884 3.795 7.389V4.695C3.795 4.2 4.197 3.796 4.693 3.796H7.387C7.883 3.796 8.285 3.394 8.285 2.898C8.285 2.403 7.883 2 7.387 2H4.693Z",
          fill: "#E76B5F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.6108 2C16.1148 2 15.7148 2.403 15.7148 2.898C15.7148 3.394 16.1148 3.796 16.6108 3.796H19.3068C19.8018 3.796 20.2028 4.2 20.2028 4.695V7.389C20.2028 7.884 20.6048 8.287 21.1008 8.287C21.5968 8.287 21.9988 7.884 21.9988 7.389V4.695C21.9988 3.206 20.7928 2 19.3068 2H16.6108Z",
          fill: "#E76B5F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2 16.613V19.306C2 20.794 3.206 22 4.693 22H7.387C7.883 22 8.285 21.598 8.285 21.101C8.285 20.606 7.883 20.205 7.387 20.205H4.693C4.197 20.205 3.795 19.802 3.795 19.306V16.613C3.795 16.117 3.394 15.714 2.898 15.714C2.401 15.714 2 16.117 2 16.613Z",
          fill: "#E76B5F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M20.2028 16.613V19.306C20.2028 19.802 19.8018 20.205 19.3068 20.205H16.6108C16.1148 20.205 15.7148 20.606 15.7148 21.101C15.7148 21.598 16.1148 22 16.6108 22H19.3068C20.7928 22 21.9988 20.794 21.9988 19.306V16.613C21.9988 16.117 21.5968 15.714 21.1008 15.714C20.6048 15.714 20.2028 16.117 20.2028 16.613Z",
          fill: "#E76B5F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.4995 7.001C13.4995 6.72382 13.724 6.5 13.9995 6.5H17.1435C17.419 6.5 17.6435 6.72382 17.6435 7.001V10.143C17.6435 10.4202 17.42 10.643 17.1435 10.643H13.9995C13.723 10.643 13.4995 10.4202 13.4995 10.143V7.001Z",
          fill: "#F7B1AB",
          stroke: "#E76B5F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.49951 7.001C6.49951 6.72382 6.72398 6.5 6.99951 6.5H10.1435C10.419 6.5 10.6435 6.72382 10.6435 7.001V10.143C10.6435 10.4202 10.42 10.643 10.1435 10.643H6.99951C6.723 10.643 6.49951 10.4202 6.49951 10.143V7.001Z",
          fill: "#F7B1AB",
          stroke: "#E76B5F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.49951 14.001C6.49951 13.7238 6.72398 13.5 6.99951 13.5H10.1435C10.419 13.5 10.6435 13.7238 10.6435 14.001V17.143C10.6435 17.4202 10.42 17.643 10.1435 17.643H6.99951C6.723 17.643 6.49951 17.4202 6.49951 17.143V14.001Z",
          fill: "#F7B1AB",
          stroke: "#E76B5F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.9995 15.5C12.9995 16.8802 14.1183 18 15.4995 18C16.8798 18 17.9995 16.8802 17.9995 15.5C17.9995 14.1198 16.8798 13 15.4995 13C14.1183 13 12.9995 14.1198 12.9995 15.5Z",
          fill: "#F7B1AB"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 568294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ RatingAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RatingAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M11.9999 3.45825L14.9752 8.41945L20.613 9.71606L16.814 14.0789L17.3231 19.8414L11.9999 17.5766L6.67664 19.8414L7.18567 14.0789L3.38672 9.71606L9.02452 8.41945L11.9999 3.45825Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 802705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ RefreshOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RefreshOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3719 2.48965C19.3498 2.07603 18.9965 1.75869 18.5829 1.78085C18.1693 1.80301 17.8519 2.15628 17.8741 2.5699L17.9659 4.28366C16.3174 3.00646 14.2461 2.24608 12 2.24608C6.61584 2.24608 2.25 6.61081 2.25 11.9961C2.25 17.3814 6.61584 21.7461 12 21.7461C17.3852 21.7461 21.75 17.3813 21.75 11.9961C21.75 11.3831 21.6938 10.7832 21.5854 10.2C21.5097 9.79279 21.1182 9.52402 20.7109 9.59971C20.3037 9.67541 20.0349 10.0669 20.1106 10.4741C20.2022 10.967 20.25 11.4751 20.25 11.9961C20.25 16.5529 16.5568 20.2461 12 20.2461C7.44416 20.2461 3.75 16.5528 3.75 11.9961C3.75 7.43935 7.44416 3.74608 12 3.74608C13.9066 3.74608 15.6616 4.39206 17.0582 5.47795L15.1388 5.52197C14.7247 5.53147 14.3967 5.87486 14.4062 6.28897C14.4157 6.70307 14.7591 7.03107 15.1732 7.02158L18.8362 6.93758C19.039 6.93293 19.2313 6.84629 19.3692 6.69745C19.5071 6.5486 19.5788 6.35025 19.5679 6.14765L19.3719 2.48965Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 971165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ SaveOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const SaveOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 25 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.25 3.5C5.00736 3.5 4 4.50736 4 5.75V18.2506C4 19.4932 5.00736 20.5006 6.25 20.5006H18.7506C19.9932 20.5006 21.0006 19.4932 21.0006 18.2506V8.20357C21.0006 7.87205 20.8689 7.55411 20.6345 7.31969L17.1809 3.86612C16.9465 3.6317 16.6285 3.5 16.297 3.5H6.25ZM2.5 5.75C2.5 3.67893 4.17893 2 6.25 2H16.297C17.0264 2 17.7258 2.28973 18.2416 2.80546L21.6951 6.25903C22.2109 6.77475 22.5006 7.47423 22.5006 8.20357V18.2506C22.5006 20.3216 20.8217 22.0006 18.7506 22.0006H6.25C4.17893 22.0006 2.5 20.3217 2.5 18.2506V5.75ZM7.94943 12.75C7.81136 12.75 7.69943 12.8619 7.69943 13V17.5502C7.69943 17.9644 7.36365 18.3002 6.94943 18.3002C6.53522 18.3002 6.19943 17.9644 6.19943 17.5502V13C6.19943 12.0335 6.98294 11.25 7.94943 11.25H17.0498C18.0163 11.25 18.7998 12.0335 18.7998 13V17.5502C18.7998 17.9644 18.464 18.3002 18.0498 18.3002C17.6356 18.3002 17.2998 17.9644 17.2998 17.5502V13C17.2998 12.8619 17.1879 12.75 17.0498 12.75H7.94943ZM16.0253 6.44992C16.0253 6.03571 15.6895 5.69992 15.2753 5.69992C14.8611 5.69992 14.5253 6.03571 14.5253 6.44992V8.3007C14.5253 8.71492 14.8611 9.0507 15.2753 9.0507C15.6895 9.0507 16.0253 8.71492 16.0253 8.3007V6.44992Z",
          fill: "#9E9E9E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 809442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ScanningOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ScanningOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 4.75C5.30964 4.75 4.75 5.30964 4.75 6V7.34375C4.75 7.75797 4.41421 8.09375 4 8.09375C3.58579 8.09375 3.25 7.75797 3.25 7.34375V6C3.25 4.48122 4.48122 3.25 6 3.25H7.34375C7.75797 3.25 8.09375 3.58579 8.09375 4C8.09375 4.41421 7.75797 4.75 7.34375 4.75H6ZM15.7391 4C15.7391 3.58579 16.0749 3.25 16.4891 3.25H17.8328C19.3516 3.25 20.5828 4.48122 20.5828 6V7.34375C20.5828 7.75797 20.247 8.09375 19.8328 8.09375C19.4186 8.09375 19.0828 7.75797 19.0828 7.34375V6C19.0828 5.30964 18.5232 4.75 17.8328 4.75H16.4891C16.0749 4.75 15.7391 4.41421 15.7391 4ZM20.5828 16.4893C20.5828 16.075 20.247 15.7393 19.8328 15.7393C19.4186 15.7393 19.0828 16.075 19.0828 16.4893V17.833C19.0828 18.5234 18.5232 19.083 17.8328 19.083H16.4891C16.0749 19.083 15.7391 19.4188 15.7391 19.833C15.7391 20.2472 16.0749 20.583 16.4891 20.583H17.8328C19.3516 20.583 20.5828 19.3518 20.5828 17.833V16.4893ZM4 15.7393C4.41421 15.7393 4.75 16.075 4.75 16.4893V17.833C4.75 18.5234 5.30964 19.083 6 19.083H7.34375C7.75797 19.083 8.09375 19.4188 8.09375 19.833C8.09375 20.2472 7.75797 20.583 7.34375 20.583H6C4.48122 20.583 3.25 19.3518 3.25 17.833V16.4893C3.25 16.075 3.58579 15.7393 4 15.7393ZM3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25H3Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 818303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ SettingAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const SettingAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9998 1.68457C10.6247 1.68457 9.51066 2.79862 9.51066 4.1737V4.71316C9.20012 4.81908 8.89852 4.94413 8.607 5.08721L8.22577 4.70598C7.25375 3.73396 5.678 3.73396 4.70598 4.70598C3.73396 5.678 3.73396 7.25375 4.70598 8.22577L5.08721 8.607C4.94413 8.89852 4.81908 9.20012 4.71316 9.51066H4.1737C2.79973 9.51066 1.68457 10.6245 1.68457 11.9998C1.68457 13.3749 2.79862 14.4889 4.1737 14.4889H4.71316C4.81908 14.7995 4.94413 15.1011 5.08721 15.3926L4.70598 15.7738C3.73396 16.7458 3.73396 18.3216 4.70598 19.2936C5.678 20.2656 7.25375 20.2656 8.22577 19.2936L8.60688 18.9125C8.8984 19.0556 9.20013 19.1806 9.51066 19.2865V19.8259C9.51066 21.1998 10.6245 22.315 11.9998 22.315C13.3749 22.315 14.4889 21.201 14.4889 19.8259V19.2864C14.7995 19.1805 15.1011 19.0554 15.3926 18.9124L15.7738 19.2936C16.7458 20.2656 18.3216 20.2656 19.2936 19.2936C20.2656 18.3216 20.2656 16.7458 19.2936 15.7738L18.9125 15.3927C19.0556 15.1012 19.1806 14.7994 19.2865 14.4889H19.8259C21.1998 14.4889 22.315 13.3751 22.315 11.9998C22.315 10.6247 21.201 9.51066 19.8259 9.51066H19.2864C19.1805 9.20012 19.0554 8.89852 18.9124 8.607L19.2936 8.22577C20.2656 7.25375 20.2656 5.678 19.2936 4.70598C18.3216 3.73396 16.7458 3.73396 15.7738 4.70598L15.3926 5.08721C15.1011 4.94413 14.7995 4.81908 14.4889 4.71316V4.1737C14.4889 2.79973 13.3751 1.68457 11.9998 1.68457ZM11.0107 4.1737C11.0107 3.62704 11.4531 3.18457 11.9998 3.18457C12.5462 3.18457 12.9889 3.62767 12.9889 4.1737V5.27109C12.9889 5.61309 13.2203 5.91178 13.5514 5.99728C14.1195 6.14396 14.6545 6.36729 15.1476 6.65802C15.4422 6.83173 15.817 6.78413 16.0588 6.54229L16.8345 5.76664C17.2207 5.3804 17.8467 5.3804 18.2329 5.76664C18.6192 6.15288 18.6192 6.77887 18.2329 7.16511L17.4573 7.94076C17.2154 8.1826 17.1678 8.55741 17.3416 8.85202C17.6323 9.34511 17.8556 9.88005 18.0023 10.4482C18.0878 10.7793 18.3865 11.0107 18.7285 11.0107H19.8259C20.3725 11.0107 20.815 11.4531 20.815 11.9998C20.815 12.5462 20.3719 12.9889 19.8259 12.9889H18.7285C18.3865 12.9889 18.0878 13.2203 18.0023 13.5514C17.8555 14.1198 17.6322 14.6554 17.3418 15.1471C17.1678 15.4418 17.2153 15.8168 17.4573 16.0588L18.2329 16.8345C18.6192 17.2207 18.6192 17.8467 18.2329 18.2329C17.8467 18.6192 17.2207 18.6192 16.8345 18.2329L16.0588 17.4573C15.817 17.2154 15.4422 17.1678 15.1476 17.3416C14.6545 17.6323 14.1195 17.8556 13.5514 18.0023C13.2203 18.0878 12.9889 18.3865 12.9889 18.7285V19.8259C12.9889 20.3725 12.5464 20.815 11.9998 20.815C11.4534 20.815 11.0107 20.3719 11.0107 19.8259V18.7285C11.0107 18.3865 10.7793 18.0878 10.4482 18.0023C9.87976 17.8555 9.34415 17.6322 8.85247 17.3418C8.55781 17.1678 8.18273 17.2153 7.94076 17.4573L7.16511 18.2329C6.77887 18.6192 6.15288 18.6192 5.76664 18.2329C5.3804 17.8467 5.3804 17.2207 5.76664 16.8345L6.54229 16.0588C6.78413 15.817 6.83173 15.4422 6.65802 15.1476C6.36729 14.6545 6.14396 14.1195 5.99728 13.5514C5.91178 13.2203 5.61309 12.9889 5.27109 12.9889H4.1737C3.62704 12.9889 3.18457 12.5464 3.18457 11.9998C3.18457 11.4534 3.62767 11.0107 4.1737 11.0107H5.27109C5.61309 11.0107 5.91178 10.7793 5.99728 10.4482C6.14396 9.88005 6.36729 9.34511 6.65802 8.85202C6.83173 8.55741 6.78413 8.1826 6.54229 7.94076L5.76664 7.16511C5.3804 6.77887 5.3804 6.15288 5.76664 5.76664C6.15288 5.3804 6.77887 5.3804 7.16511 5.76664L7.94076 6.54229C8.1826 6.78413 8.55741 6.83173 8.85202 6.65802C9.34511 6.36729 9.88005 6.14396 10.4482 5.99728C10.7793 5.91178 11.0107 5.61309 11.0107 5.27109V4.1737ZM10.1411 11.9998C10.1411 10.9733 10.9732 10.1411 11.9998 10.1411C13.0263 10.1411 13.8585 10.9733 13.8585 11.9998C13.8585 13.0263 13.0263 13.8585 11.9998 13.8585C10.9732 13.8585 10.1411 13.0263 10.1411 11.9998ZM11.9998 8.64111C10.1448 8.64111 8.64108 10.1449 8.64108 11.9998C8.64108 13.8548 10.1448 15.3585 11.9998 15.3585C13.8547 15.3585 15.3585 13.8548 15.3585 11.9998C15.3585 10.1449 13.8547 8.64111 11.9998 8.64111Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 999308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ShieldOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShieldOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M20 11.1821C20 15.7231 16.587 19.9691 12 21.0001C7.413 19.9691 4 15.7231 4 11.1821V7.61508C4.00004 7.21801 4.11827 6.82994 4.33963 6.5003C4.561 6.17066 4.87547 5.91437 5.243 5.76408L10.243 3.71808C11.369 3.25706 12.631 3.25706 13.757 3.71808L18.757 5.76408C19.1245 5.91437 19.439 6.17066 19.6604 6.5003C19.8817 6.82994 20 7.21801 20 7.61508V11.1821Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.25 10.125L11.5 13.875L9.25 11.625",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 439865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ShippingOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShippingOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75 4C3.33579 4 3 4.33579 3 4.75C3 5.16421 3.33579 5.5 3.75 5.5H10.875V7.5625V17.6875C10.875 18.1017 11.2108 18.4375 11.625 18.4375H12.657C12.99 19.7314 14.1646 20.6875 15.5625 20.6875C16.9604 20.6875 18.135 19.7314 18.468 18.4375H20.625C21.0392 18.4375 21.375 18.1017 21.375 17.6875V13.1875C21.375 12.9034 21.2145 12.6437 20.9604 12.5167L18.9738 11.5234L17.3897 7.29916C17.28 7.00643 17.0001 6.8125 16.6875 6.8125H12.375V4.75C12.375 4.33579 12.0392 4 11.625 4H3.75ZM4.125 7.5625C4.125 7.14829 4.46079 6.8125 4.875 6.8125H9.375C9.78921 6.8125 10.125 7.14829 10.125 7.5625C10.125 7.97671 9.78921 8.3125 9.375 8.3125H4.875C4.46079 8.3125 4.125 7.97671 4.125 7.5625ZM19.875 16.9375H18.468C18.135 15.6436 16.9604 14.6875 15.5625 14.6875C14.1646 14.6875 12.99 15.6436 12.657 16.9375H12.375V8.3125H16.1677L17.6728 12.3258C17.7392 12.5031 17.8703 12.6487 18.0396 12.7333L19.875 13.651V16.9375ZM15.5625 16.1875C14.7341 16.1875 14.0625 16.8591 14.0625 17.6875C14.0625 18.5159 14.7341 19.1875 15.5625 19.1875C16.3909 19.1875 17.0625 18.5159 17.0625 17.6875C17.0625 16.8591 16.3909 16.1875 15.5625 16.1875ZM14.625 9.8125C14.625 9.39829 14.2892 9.0625 13.875 9.0625C13.4608 9.0625 13.125 9.39829 13.125 9.8125V12.0625C13.125 12.4767 13.4608 12.8125 13.875 12.8125H16.125C16.5392 12.8125 16.875 12.4767 16.875 12.0625C16.875 11.6483 16.5392 11.3125 16.125 11.3125H14.625V9.8125ZM5.25 10.375C5.25 9.96079 5.58579 9.625 6 9.625H9.375C9.78921 9.625 10.125 9.96079 10.125 10.375C10.125 10.7892 9.78921 11.125 9.375 11.125H6C5.58579 11.125 5.25 10.7892 5.25 10.375ZM7.125 12.4375C6.71079 12.4375 6.375 12.7733 6.375 13.1875C6.375 13.6017 6.71079 13.9375 7.125 13.9375H9.375C9.78921 13.9375 10.125 13.6017 10.125 13.1875C10.125 12.7733 9.78921 12.4375 9.375 12.4375H7.125Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 50838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ShopColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShopColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12.9311 9.2069C12.8488 9.2069 12.7699 9.1742 12.7117 9.116C12.6535 9.0578 12.6208 8.97886 12.6208 8.89655V5.7931C12.6208 5.21694 12.3919 4.66438 11.9845 4.25698C11.5771 3.84957 11.0245 3.62069 10.4484 3.62069C9.87222 3.62069 9.31966 3.84957 8.91225 4.25698C8.50484 4.66438 8.27596 5.21694 8.27596 5.7931V8.89655C8.27596 8.97886 8.24327 9.0578 8.18507 9.116C8.12686 9.1742 8.04793 9.2069 7.96562 9.2069C7.88331 9.2069 7.80437 9.1742 7.74617 9.116C7.68797 9.0578 7.65527 8.97886 7.65527 8.89655V5.7931C7.65527 5.05233 7.94955 4.34189 8.47335 3.81808C8.99716 3.29427 9.7076 3 10.4484 3C11.1892 3 11.8996 3.29427 12.4234 3.81808C12.9472 4.34189 13.2415 5.05233 13.2415 5.7931V8.89655C13.2415 8.97886 13.2088 9.0578 13.1506 9.116C13.0924 9.1742 13.0134 9.2069 12.9311 9.2069Z",
          fill: "#DADCDE"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.5517 20.0689H3L3.62069 7.65515H12.931L13.5517 20.0689Z",
          fill: "#EB423F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.0346 20.0689H13.5518L12.9312 7.65515H15.4139L16.0346 20.0689Z",
          fill: "#D13330"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M14.8116 18.5168C14.8054 18.5172 14.7992 18.5172 14.793 18.5172C14.7138 18.5172 14.6377 18.4869 14.5802 18.4326C14.5227 18.3783 14.488 18.3041 14.4834 18.2251L13.8627 7.67338C13.8623 7.66718 13.8623 7.66136 13.8623 7.65515H14.4838L15.1033 18.1886C15.1081 18.2708 15.0801 18.3516 15.0254 18.4131C14.9707 18.4747 14.8938 18.512 14.8116 18.5168Z",
          fill: "#A82A27"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M20.9999 20.069H18.5172L18.4784 19.5674V19.567L17.8965 12H20.3792L20.9514 19.4363V19.4366L20.9999 20.069Z",
          fill: "#EBA72E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M19.7897 18.5157C19.7793 18.5168 19.7688 18.5173 19.7583 18.5173C19.6814 18.5172 19.6073 18.4885 19.5503 18.4369C19.4934 18.3853 19.4576 18.3144 19.4499 18.2379L19.4386 18.127L18.8292 12.031C18.8281 12.0207 18.8276 12.0104 18.8276 12H19.4499L20.0597 18.0987L20.0675 18.1759C20.0715 18.2164 20.0676 18.2574 20.0558 18.2964C20.0441 18.3354 20.0248 18.3718 19.999 18.4033C19.9732 18.4349 19.9414 18.461 19.9055 18.4803C19.8696 18.4996 19.8303 18.5116 19.7897 18.5157Z",
          fill: "#E09F2C"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21.0001 20.069H20.6269L19.7587 18.7663L18.8905 20.069H18.5173L18.4785 19.5674V19.567L19.4386 18.127L19.5003 18.0347C19.5287 17.9922 19.5671 17.9574 19.6122 17.9333C19.6573 17.9092 19.7076 17.8966 19.7587 17.8966C19.8098 17.8966 19.8601 17.9092 19.9052 17.9333C19.9502 17.9574 19.9887 17.9922 20.0171 18.0347L20.0597 18.0987L20.9516 19.4363V19.4367L21.0001 20.069Z",
          fill: "#E09F2C"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.5172 20.069H10.4482L11.0689 12H17.8965L18.5172 20.069Z",
          fill: "#F7B030"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M14.793 17.8966H14.1723C13.7609 17.8961 13.3665 17.7325 13.0756 17.4416C12.7847 17.1507 12.6211 16.7563 12.6206 16.3449V13.8621C12.6206 13.7798 12.6533 13.7009 12.7115 13.6427C12.7697 13.5845 12.8486 13.5518 12.931 13.5518C13.0133 13.5518 13.0922 13.5845 13.1504 13.6427C13.2086 13.7009 13.2413 13.7798 13.2413 13.8621V16.3449C13.2416 16.5917 13.3398 16.8284 13.5143 17.0029C13.6888 17.1774 13.9255 17.2756 14.1723 17.2759H14.793C15.0399 17.2756 15.2765 17.1774 15.4511 17.0029C15.6256 16.8284 15.7238 16.5917 15.7241 16.3449V13.8621C15.7241 13.7798 15.7568 13.7009 15.815 13.6427C15.8732 13.5845 15.9521 13.5518 16.0344 13.5518C16.1167 13.5518 16.1956 13.5845 16.2538 13.6427C16.312 13.7009 16.3447 13.7798 16.3447 13.8621V16.3449C16.3443 16.7563 16.1806 17.1507 15.8897 17.4416C15.5988 17.7325 15.2044 17.8961 14.793 17.8966Z",
          fill: "#E9EEF2"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.79297 8.89661H6.41366V10.7587H5.79297V8.89661Z",
          fill: "#DADCDE"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.10331 9.2069C6.02101 9.2069 5.94207 9.1742 5.88387 9.116C5.82567 9.0578 5.79297 8.97886 5.79297 8.89655V5.7931C5.79297 5.05233 6.08724 4.34189 6.61105 3.81808C7.13486 3.29427 7.84529 3 8.58607 3C9.32685 3 10.0373 3.29427 10.5611 3.81808C11.0849 4.34189 11.3792 5.05233 11.3792 5.7931V8.89655C11.3792 8.97886 11.3465 9.0578 11.2883 9.116C11.2301 9.1742 11.1511 9.2069 11.0688 9.2069C10.9865 9.2069 10.9076 9.1742 10.8494 9.116C10.7912 9.0578 10.7585 8.97886 10.7585 8.89655V5.7931C10.7585 5.21694 10.5296 4.66438 10.1222 4.25698C9.71479 3.84957 9.16223 3.62069 8.58607 3.62069C8.00991 3.62069 7.45735 3.84957 7.04994 4.25698C6.64254 4.66438 6.41366 5.21694 6.41366 5.7931V8.89655C6.41366 8.97886 6.38096 9.0578 6.32276 9.116C6.26456 9.1742 6.18562 9.2069 6.10331 9.2069Z",
          fill: "#E9EEF2"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.03443 13.2414H5.17236V10.7586L6.1034 10.1379L7.03443 10.7586V13.2414Z",
          fill: "#F7B030"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 84962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ShopOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShopOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.81143 3.61413C4.94697 3.38822 5.1911 3.25 5.45455 3.25H18.5455C18.8089 3.25 19.053 3.38822 19.1886 3.61413L21.6431 7.70503C21.7128 7.82111 21.7497 7.95386 21.75 8.08923C21.7533 9.57322 20.7353 10.8645 19.2915 11.2077C18.2238 11.4615 17.1308 11.1474 16.3649 10.43C15.7837 10.9767 15.007 11.2957 14.1817 11.2957C13.3571 11.2957 12.581 10.9773 12 10.4315C11.419 10.9773 10.6429 11.2957 9.81832 11.2957C8.99299 11.2957 8.21626 10.9767 7.63509 10.43C6.86923 11.1474 5.77616 11.4615 4.70846 11.2077C3.26469 10.8645 2.24668 9.57322 2.25001 8.08923C2.25031 7.95386 2.28724 7.82111 2.35689 7.70503L4.81143 3.61413ZM5.87919 4.75L3.76008 8.28185C3.8373 8.9883 4.35086 9.58091 5.05534 9.74836C5.82192 9.93057 6.61313 9.56149 6.9661 8.85703C7.09348 8.6028 7.35367 8.44247 7.63802 8.443C7.92237 8.44352 8.18198 8.60481 8.30841 8.8595C8.5931 9.43297 9.17808 9.79566 9.81832 9.79566C10.4586 9.79566 11.0435 9.43297 11.3282 8.8595C11.4549 8.60436 11.7151 8.443 12 8.443C12.2849 8.443 12.5451 8.60436 12.6718 8.8595C12.9565 9.43297 13.5414 9.79566 14.1817 9.79566C14.8219 9.79566 15.4069 9.43297 15.6916 8.8595C15.818 8.60481 16.0776 8.44352 16.362 8.443C16.6463 8.44247 16.9065 8.6028 17.0339 8.85703C17.3869 9.56149 18.1781 9.93057 18.9447 9.74836C19.6491 9.58091 20.1627 8.9883 20.2399 8.28185L18.1208 4.75H5.87919ZM5.45454 12.25C5.86876 12.25 6.20454 12.5858 6.20454 13V19.3636C6.20454 19.5017 6.31647 19.6136 6.45454 19.6136H9.61365V15.4546C9.61365 15.0404 9.94943 14.7046 10.3636 14.7046H13.6364C14.0506 14.7046 14.3864 15.0404 14.3864 15.4546V19.6136H17.5454C17.6835 19.6136 17.7954 19.5017 17.7954 19.3636V13C17.7954 12.5858 18.1312 12.25 18.5454 12.25C18.9597 12.25 19.2954 12.5858 19.2954 13V19.3636C19.2954 20.3301 18.5119 21.1136 17.5454 21.1136H13.6447C13.642 21.1137 13.6392 21.1137 13.6364 21.1137C13.6336 21.1137 13.6308 21.1137 13.628 21.1136H10.372C10.3692 21.1137 10.3664 21.1137 10.3636 21.1137C10.3609 21.1137 10.3581 21.1137 10.3553 21.1136H6.45454C5.48805 21.1136 4.70454 20.3301 4.70454 19.3636V13C4.70454 12.5858 5.04033 12.25 5.45454 12.25ZM11.1136 19.6136H12.8864V16.2046H11.1136V19.6136Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 295624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ShoppingCartAddColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShoppingCartAddColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 18 18", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_21440_17520)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M13.5 9C12.7098 9.00092 11.9333 8.7935 11.2488 8.39865C10.5643 8.0038 9.99604 7.43547 9.60123 6.75096C9.20642 6.06645 8.99904 5.28995 9.00001 4.49974C9.00098 3.70953 9.21026 2.93354 9.60675 2.25H3.1815L3.15 1.986C3.08537 1.43895 2.82229 0.934615 2.41064 0.568578C1.99899 0.202541 1.46736 0.000234627 0.9165 0L0.75 0C0.551088 0 0.360322 0.0790176 0.21967 0.21967C0.0790176 0.360322 0 0.551088 0 0.75C0 0.948912 0.0790176 1.13968 0.21967 1.28033C0.360322 1.42098 0.551088 1.5 0.75 1.5H0.9165C1.1002 1.50002 1.2775 1.56747 1.41478 1.68954C1.55206 1.81161 1.63976 1.97981 1.66125 2.16225L2.69325 10.9373C2.80039 11.8498 3.23886 12.6913 3.92543 13.302C4.612 13.9127 5.49889 14.25 6.41775 14.25H14.25C14.4489 14.25 14.6397 14.171 14.7803 14.0303C14.921 13.8897 15 13.6989 15 13.5C15 13.3011 14.921 13.1103 14.7803 12.9697C14.6397 12.829 14.4489 12.75 14.25 12.75H6.41775C5.95341 12.7488 5.5008 12.6041 5.12201 12.3355C4.74321 12.067 4.45678 11.6878 4.302 11.25H13.2427C14.122 11.2501 14.9733 10.9412 15.6479 10.3773C16.3225 9.81348 16.7775 9.03052 16.9335 8.16525L17.112 7.176C16.6948 7.74162 16.1506 8.20136 15.5232 8.51817C14.8959 8.83499 14.2028 9.00003 13.5 9V9Z",
              fill: "#1435C3"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5.25 18.0005C6.07842 18.0005 6.74999 17.3289 6.74999 16.5005C6.74999 15.6721 6.07842 15.0005 5.25 15.0005C4.42157 15.0005 3.75 15.6721 3.75 16.5005C3.75 17.3289 4.42157 18.0005 5.25 18.0005Z",
              fill: "#1435C3"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M12.75 18.0005C13.5784 18.0005 14.25 17.3289 14.25 16.5005C14.25 15.6721 13.5784 15.0005 12.75 15.0005C11.9216 15.0005 11.25 15.6721 11.25 16.5005C11.25 17.3289 11.9216 18.0005 12.75 18.0005Z",
              fill: "#1435C3"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.25 5.25049H12.75V6.75049C12.75 6.9494 12.829 7.14017 12.9697 7.28082C13.1103 7.42147 13.3011 7.50049 13.5 7.50049C13.6989 7.50049 13.8897 7.42147 14.0303 7.28082C14.171 7.14017 14.25 6.9494 14.25 6.75049V5.25049H15.75C15.9489 5.25049 16.1397 5.17147 16.2803 5.03082C16.421 4.89017 16.5 4.6994 16.5 4.50049C16.5 4.30158 16.421 4.11081 16.2803 3.97016C16.1397 3.82951 15.9489 3.75049 15.75 3.75049H14.25V2.25049C14.25 2.05158 14.171 1.86081 14.0303 1.72016C13.8897 1.57951 13.6989 1.50049 13.5 1.50049C13.3011 1.50049 13.1103 1.57951 12.9697 1.72016C12.829 1.86081 12.75 2.05158 12.75 2.25049V3.75049H11.25C11.0511 3.75049 10.8603 3.82951 10.7197 3.97016C10.579 4.11081 10.5 4.30158 10.5 4.50049C10.5 4.6994 10.579 4.89017 10.7197 5.03082C10.8603 5.17147 11.0511 5.25049 11.25 5.25049V5.25049Z",
              fill: "#1435C3"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_21440_17520" },
            child: [
              {
                tag: "rect",
                attr: { width: "18", height: "18", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 314323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ShoppingCartColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShoppingCartColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5.94238 8.09338L7.91086 15.8683L19.7461 15.889C19.9875 15.8894 20.1985 15.7261 20.2586 15.4922L21.983 8.78014C22.0687 8.44635 21.817 8.12116 21.4723 8.12053L5.94238 8.09338Z",
          fill: "#FF6D3A"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.919 14.7489C9.78806 14.7489 9.66881 14.6605 9.63521 14.5277L8.38404 9.58602C8.34431 9.42914 8.43927 9.2698 8.59615 9.23012C8.75314 9.19035 8.91236 9.28539 8.95205 9.44223L10.2032 14.384C10.2429 14.5408 10.148 14.7002 9.99111 14.7399C9.96697 14.746 9.94279 14.7489 9.919 14.7489Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.6122 14.7535C12.4614 14.7535 12.3333 14.6378 12.3205 14.4848L11.9092 9.54456C11.8958 9.38335 12.0156 9.24175 12.1769 9.22831C12.3382 9.21495 12.4797 9.33468 12.4932 9.49597L12.9045 14.4363C12.9179 14.5975 12.798 14.7391 12.6368 14.7525C12.6285 14.7532 12.6203 14.7535 12.6122 14.7535Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.3055 14.7583C15.297 14.7583 15.2884 14.7579 15.2799 14.7571C15.1186 14.7432 14.9993 14.6011 15.0133 14.44L15.4419 9.50116C15.4559 9.33999 15.5985 9.22065 15.7591 9.23463C15.9203 9.24862 16.0397 9.39065 16.0256 9.55182L15.597 14.4906C15.5838 14.6432 15.4559 14.7583 15.3055 14.7583Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M17.9988 14.7629C17.9747 14.7629 17.9501 14.7599 17.9257 14.7536C17.769 14.7134 17.6746 14.5537 17.7149 14.397L18.9833 9.45965C19.0235 9.30297 19.1831 9.20852 19.34 9.24879C19.4967 9.28906 19.5911 9.44875 19.5508 9.60543L18.2823 14.5428C18.2484 14.6751 18.1293 14.7629 17.9988 14.7629Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M20.7952 18.883L8.51922 18.8616C8.25051 18.8611 8.01633 18.6785 7.95035 18.418L4.83457 6.11185L2.37124 5.1345C2.06944 5.01473 1.92186 4.67301 2.04159 4.37126C2.16132 4.06946 2.50308 3.92188 2.80483 4.04157L5.54754 5.12977C5.72297 5.19934 5.85433 5.34895 5.90062 5.53188L8.97801 17.6866L20.7972 17.7073C21.1219 17.7079 21.3846 17.9715 21.3841 18.2962C21.3835 18.6209 21.1198 18.8836 20.7952 18.883Z",
          fill: "#CCCCCC"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.78223 20.0409C9.68509 20.0409 10.417 19.309 10.417 18.4061C10.417 17.5033 9.68509 16.7714 8.78223 16.7714C7.87937 16.7714 7.14746 17.5033 7.14746 18.4061C7.14746 19.309 7.87937 20.0409 8.78223 20.0409Z",
          fill: "#1D4859"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.78127 18.97C8.47029 18.9694 8.21772 18.716 8.21826 18.405C8.21881 18.094 8.47225 17.8415 8.78322 17.842C9.0942 17.8426 9.34674 18.096 9.34619 18.407C9.34569 18.7179 9.09225 18.9705 8.78127 18.97Z",
          fill: "#F3E8D6"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.3687 20.0576C19.2715 20.0576 20.0034 19.3257 20.0034 18.4229C20.0034 17.52 19.2715 16.7881 18.3687 16.7881C17.4658 16.7881 16.7339 17.52 16.7339 18.4229C16.7339 19.3257 17.4658 20.0576 18.3687 20.0576Z",
          fill: "#1D4859"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.3677 18.9867C18.0567 18.9862 17.8041 18.7327 17.8047 18.4217C17.8052 18.1108 18.0587 17.8582 18.3697 17.8588C18.6806 17.8593 18.9332 18.1127 18.9326 18.4237C18.9321 18.7347 18.6787 18.9872 18.3677 18.9867Z",
          fill: "#F3E8D6"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 757767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ShoppingCartFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShoppingCartFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { fill: "none", viewBox: "0 0 24 24" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.5 4.25a.75.75 0 0 1 .75-.75h.558c.95 0 1.52.639 1.845 1.233.217.396.374.855.497 1.271A1.29 1.29 0 0 1 6.25 6h12.498c.83 0 1.43.794 1.202 1.593l-1.828 6.409a2.75 2.75 0 0 1-2.644 1.996H9.53a2.75 2.75 0 0 1-2.652-2.022l-.76-2.772-1.26-4.248-.001-.008c-.156-.567-.302-1.098-.52-1.494C4.128 5.069 3.96 5 3.809 5H3.25a.75.75 0 0 1-.75-.75ZM9 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          fill: "#1CA085"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 794519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ShortingOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShortingOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.10859 4.75122C8.10926 4.33701 7.77403 4.00068 7.35981 4C6.9456 3.99933 6.60927 4.33456 6.60859 4.74878L6.58919 16.642L4.28843 14.2694C4.00007 13.972 3.52526 13.9647 3.22789 14.2531C2.93053 14.5414 2.92322 15.0162 3.21158 15.3136L6.79775 19.0118C6.85793 19.0739 6.92773 19.1244 7.00372 19.162C7.0489 19.1844 7.09666 19.2024 7.14643 19.2153C7.20785 19.2314 7.27158 19.2397 7.33618 19.2397C7.40036 19.2397 7.46367 19.2315 7.52472 19.2156C7.57301 19.2031 7.61941 19.186 7.6634 19.1646C7.74142 19.1268 7.81305 19.0753 7.8746 19.0118L11.4608 15.3136C11.7491 15.0162 11.7418 14.5414 11.4445 14.2531C11.1471 13.9647 10.6723 13.972 10.3839 14.2694L8.0892 16.6358L8.10859 4.75122ZM16.637 19.9343C16.2228 19.9336 15.8875 19.5973 15.8882 19.183L15.9076 7.29819L13.6124 9.66514C13.324 9.9625 12.8492 9.96981 12.5518 9.68145C12.2545 9.3931 12.2472 8.91828 12.5355 8.62092L16.1217 4.92267C16.1822 4.86025 16.2525 4.80948 16.329 4.77183C16.4294 4.72229 16.5424 4.69453 16.6618 4.69473C16.8814 4.69508 17.0789 4.78979 17.2158 4.94042L20.7847 8.62092C21.0731 8.91828 21.0658 9.3931 20.7684 9.68145C20.4711 9.96981 19.9962 9.9625 19.7079 9.66514L17.4076 7.29298L17.3882 19.1855C17.3875 19.5997 17.0512 19.9349 16.637 19.9343Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 949380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ShowroomOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShowroomOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { version: "1.1", viewBox: "0 0 1024 1024" },
    child: [
      { tag: "title", attr: {} },
      { tag: "g", attr: { id: "icomoon-ignore" }, child: [] },
      {
        tag: "path",
        attr: {
          d: "M983.040 967.107h-66.847v-526.213c-0.045-14.262-10.403-26.091-24.005-28.422l-0.171-0.024-219.023-32.717v-231.823c-0.046-15.692-12.755-28.4-28.442-28.447h-64.004v-91.013c-0.046-15.688-12.749-28.394-28.431-28.447h-386.852c-15.692 0.046-28.4 12.755-28.447 28.442v91.027h-64c-15.692 0.046-28.4 12.755-28.447 28.442v819.204h-5.683c-15.711 0-28.447 12.736-28.447 28.447s12.736 28.447 28.447 28.447h944.353c15.711 0 28.447-12.736 28.447-28.447s-12.736-28.447-28.447-28.447v0zM193.71 56.893h329.953v62.577h-329.953zM101.263 176.353h514.847v790.753h-514.847zM672.993 967.107v-529.060l186.307 27.023v502.036zM303.217 250.307h-108.083c-15.692 0.046-28.4 12.755-28.447 28.442v108.087c0 15.711 12.736 28.447 28.447 28.447s28.447-12.736 28.447-28.447v0-79.636h79.647c15.711 0 28.447-12.736 28.447-28.447s-12.736-28.447-28.447-28.447v0zM520.817 250.307h-108.083c-15.692 0.046-28.4 12.755-28.447 28.442v108.087c0 15.711 12.736 28.447 28.447 28.447s28.447-12.736 28.447-28.447v0-79.636h79.647c15.711 0 28.447-12.736 28.447-28.447s-12.736-28.447-28.447-28.447v0zM303.217 489.247h-108.083c-15.692 0.046-28.4 12.755-28.447 28.442v108.087c0 15.711 12.736 28.447 28.447 28.447s28.447-12.736 28.447-28.447v0-79.636h79.647c15.711 0 28.447-12.736 28.447-28.447s-12.736-28.447-28.447-28.447v0zM520.817 489.247h-108.083c-15.692 0.046-28.4 12.755-28.447 28.442v108.087c0 15.711 12.736 28.447 28.447 28.447s28.447-12.736 28.447-28.447v0-79.636h79.647c15.711 0 28.447-12.736 28.447-28.447s-12.736-28.447-28.447-28.447v0zM303.217 728.177h-108.083c-15.692 0.046-28.4 12.755-28.447 28.442v108.087c0 15.711 12.736 28.447 28.447 28.447s28.447-12.736 28.447-28.447v0-79.636h79.647c15.711 0 28.447-12.736 28.447-28.447s-12.736-28.447-28.447-28.447v0zM520.817 728.177h-108.083c-15.692 0.046-28.4 12.755-28.447 28.442v108.087c0 15.711 12.736 28.447 28.447 28.447s28.447-12.736 28.447-28.447v0-79.636h79.647c15.711 0 28.447-12.736 28.447-28.447s-12.736-28.447-28.447-28.447v0z"
        }
      }
    ]
  })(props);
};




/***/ })

}]);